import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const FooterWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 960px;
  background: #373435;
  color: #fff;
  justify-content: space-between;
  overflow: hidden;
  div {
    padding-top: 2rem;
    padding: 1.405rem 1.45rem;
  }
  ul {
    padding: 0 1rem;
    list-style-type: none;
    li {
      margin-bottom: 0.8rem;
      a {
        text-decoration: none;
        color: #b6b6b6;
        transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
        &:hover {
          color: #fff;
        }
      }
    }
  }
`

const Footer = () => (
  <FooterWrapper>
    <div>
      <ul>
        <li>
          <Link to="/">Inicio</Link>
        </li>
        <li>
          <Link to="/quienes-somos">Quienes Somos</Link>
        </li>
        <li>
          <Link to="/gasred">Sistema Gasred</Link>
        </li>
        <li>
          <Link to="/ubicaciones">Ubicaciones</Link>
        </li>
        <li>
          <Link to="/contacto">Contacto</Link>
        </li>
      </ul>
      Gasred ©{new Date().getFullYear()}
    </div>
    <div>Desarrollo STIN</div>
  </FooterWrapper>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js